import Vue from 'vue';
import './plugins/socketio';
import { catchException } from './plugins/bugsnag';
import { initializeVuetify } from './plugins/vuetify';
import { initializeVueI18Next } from './plugins/i18next';
import App from './App.vue';
import router from './router';
import store from './store';
import { apiClient } from './api';

Vue.config.productionTip = false;
Vue.prototype.$http = apiClient;

async function boot() {
  try {
    const i18n = await initializeVueI18Next();

    initializeVuetify(i18n);

    new Vue({
      i18n,
      router,
      store,
      render: (h) => h(App),
    }).$mount('#app');
  } catch (err) {
    new Vue({
      router,
      store,
      render: (h) => h(App),
    }).$mount('#app');

    // eslint-disable-next-line
    console.error(err, `Fatal error occurred. We can't load the application without translation`);
    catchException(err);
  }
}

boot();
